import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation Login($pin: String!) {
    login(pin: $pin) {
      access_token
      employee {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;

export const LOGIN_WITH_QR_MUTATION = gql`
  mutation LoginWithQR($qrData: String!) {
    loginWithQR(qrData: $qrData) {
      access_token
      employee {
        id
        firstName
        lastName
        email
        role
      }
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout
  }
`;

export const GET_EVENT_TYPES = gql`
  query GetEventTypes {
    eventTypes {
      id
      name
      code
      description
      color
      icon
      order
    }
  }
`;

export const CREATE_EVENT_MUTATION = gql`
  mutation CreateEvent($employeeId: String!, $eventTypeId: String!, $note: String) {
    createEvent(employeeId: $employeeId, eventTypeId: $eventTypeId, note: $note) {
      id
      timestamp
      employee {
        firstName
        lastName
      }
      eventType {
        name
        color
      }
    }
  }
`;

export const GET_RECENT_EVENTS = gql`
  query GetRecentEvents($employeeId: String!) {
    employeeEvents(employeeId: $employeeId) {
      id
      timestamp
      eventType {
        name
        code
        color
      }
    }
  }
`;

export const GET_EMPLOYEE_CURRENT_STATE = gql`
  query GetEmployeeCurrentState($employeeId: String!) {
    employeeCurrentState(employeeId: $employeeId) {
      currentState
      lastEvent {
        id
        timestamp
        eventType {
          name
          code
          color
        }
      }
      availableActions
      autoBreak
    }
  }
`;

export const REGISTER_DEVICE_WITH_TOKEN = gql`
  mutation RegisterDeviceWithToken($data: RegisterWithTokenInput!) {
    registerDeviceWithToken(data: $data) {
      success
      message
      device {
        id
        deviceName
        location
        status
        token
        fingerprint
        userAgent
        screenResolution
        timezone
        registeredAt
      }
    }
  }
`;

export const GET_DEVICE_STATUS_BY_TOKEN = gql`
  query GetDeviceStatusByToken($token: String!) {
    deviceByToken(token: $token) {
      id
      deviceName
      location
      status
      token
      fingerprint
      userAgent
      screenResolution
      timezone
      registeredAt
      approvedAt
    }
  }
`;